import { apiRequest } from "@/api/apiRequest";

export const postDonation = async body =>
  apiRequest({
    method: "POST",
    path: "donation",
    body
  });

export const fetchDonationStatus = async donationId =>
  apiRequest({
    method: "GET",
    path: `donation/payment/${donationId}`
  });
